export const SUBMIT_FOR_ALL_SHIFTS_MODEL = "submit-for-all-shifts";

const submitForAllShiftsModel = {
  workers: []
};

export default submitForAllShiftsModel;
